import { connect } from 'react-redux';
import { isTokenSent, isTokenInvalid } from 'selectors/login';
import TokenRedirect from 'components/TokenRedirect';
import { postAuthTokenRequest } from '../actions/index';

const mapStateToProps = (state) => ({
  isTokenSent: isTokenSent(state),
  isTokenInvalid: isTokenInvalid(state),
});

const mapDispatchToProps = {
  postAuthTokenRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenRedirect);
